import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "api/axiosInstance";

const USERS_TTL = 1000 * 60 * 60;

export const fetchUsers = createAsyncThunk(
    "users/list",
    async (opts, thunkAPI) => {
        try {
            const { data } = await api.get(`/users`);

            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    },
    {
        condition: (_, { getState }) => {
            const { core } = getState();

            if (core.users.length === 0) return true;
            if (!core.usersFetchedAt) return true;

            const now = Date.now();
            const age = now - core.usersFetchedAt;

            return age > USERS_TTL;
        }
    }
);

const coreSlice = createSlice({
    name: "core",
    initialState: {
        users: [],
        usersFetchedAt: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.users = action.payload;
                state.usersFetchedAt = action.payload.fetchedAt;
            })
    }
});

export default coreSlice.reducer;
